
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :

import Background from '../../../components/background/Background.jsx'
import Comments from '../../../components/comments/Comments.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx'
import ManagerMenu from '../../../components/managermenu/ManagerMenu.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EuroIcon from '@mui/icons-material/Euro';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';

//Utils
import { checkLogin } from '../../../utils/check-login.js'
import setNumResa from '../../../utils/set_num_resa.js'; //params : resaInfos
import convertHoraire from '../../../utils/convert_horaire.js';
import sortElevesCreneaux from '../../../utils/sort-eleves-creneaux.js';


function ManagerReservations() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [searchFilter, setSearchFilter] = useState("");
    let [listSorter, setListSorter] = useState({ type: "date", sens: "desc" });
    let [resasInfos, setResasInfos] = useState([]);
    let [filteredResas, setFilteredResas] = useState([]);
    let [showInfos, setShowInfos] = useState([]);


    let isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
    dayjs.extend(isSameOrAfter)
    let isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
    dayjs.extend(isSameOrBefore)

    //// -- at first render :
    useEffect(() => {


        if (checkLogin() === false) {

            navigate(`/manager/login?dest=manager/reservations`)
        }

        async function initResas() { //we add this inner function to manage asynchrone
            let infosResas = await getResasAllInfos();
            setResasInfos(infosResas);

            if (searchFilter.length === 0 && filteredResas.length === 0) { setFilteredResas(infosResas); }
        } //end of async function


        initResas(); //call the inner asnchrone function

    }, [])
    //// -- 

    async function getResasAllInfos() { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/all/infos`,
            });
            //console.log(response);
            const resas = response.data;
            return resas;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    const today = dayjs(); // set the date of the current day

    function filterResas(word) {
        console.log(word);

        switch (word) {
            case "match":
                // code block
                setSearchFilter(word);
                setFilteredResas(resasInfos.filter((resa) => (resa.match === true)));
                break;
            case "unmatch":
                // code block
                setSearchFilter(word);
                setFilteredResas(resasInfos.filter((resa) => (resa.match === false)));
                break;
            case "paid":
                // code block
                setSearchFilter(word);
                setFilteredResas(resasInfos.filter((resa) => (resa.solde === 0)));
                break;
            case "unpaid":
                // code block
                setSearchFilter(word);
                setFilteredResas(resasInfos.filter((resa) => (resa.solde > 0)));
                break;


            default:
                // code block
                setFilteredResas(resasInfos.filter((resa) =>
                    (setNumResa(resa) === word || String(resa.id_resa) === word || resa.Client.nom.toLowerCase() === word.toLowerCase() || resa.Client.tel === word || resa.Client.prenom.email === word.toLowerCase())
                ));
        }



    }

    function sortResas(list) {

        if (listSorter.type === "alpha") {
            if (listSorter.sens == "asc") {
                return list.toSorted((c1, c2) => c1.Client.nom.toLowerCase() > c2.Client.nom.toLowerCase());
            }
            else {
                return list.toSorted((c1, c2) => c1.Client.nom.toLowerCase() < c2.Client.nom.toLowerCase());
            }

        }
        else { //sort by date creation
            if (listSorter.sens == "asc") {
                return list.toSorted((c1, c2) => dayjs(c1.created).isAfter(dayjs(c2.created)));
            }
            else {
                return list.toSorted((c1, c2) => dayjs(c1.created).isBefore(dayjs(c2.created)));
            }
        }

    }

    function handleSort(type) {

        if (type === listSorter.type) { //// same type
            if (listSorter.sens === "asc") {
                setListSorter({ type: listSorter.type, sens: "desc" })
            }
            else {
                setListSorter({ type: listSorter.type, sens: "asc" })
            }

        }
        else {
            setListSorter({ type: type, sens: "asc" })
        }
    }

    function dateSorter(resas) {
        return resas.toSorted((r1, r2) => dayjs(r1.created).isAfter(dayjs(r2.created)));
    }

    function getBtClass(type) {
        let laClass = "manager-reservations-top-searchbar-btsort"

        laClass += type === listSorter.type ? " selected-sorter " : " "

        return laClass;

    }

    function infosShower(id) {
        //let temp = showInfos;
        let temp = [];
        let coche = false;
        if (showInfos[id]) { coche = !showInfos[id]; }
        else { coche = true; }
        temp[id] = coche;
        setShowInfos(temp);

    }

    function checkFinished(resa) {
        if (resa.CreneauEleves.length === 0) { return false; }
        let passee = false;
        let dates = sortElevesCreneaux(resa.CreneauEleves).dateList;
        let lastDate = dates[dates.length - 1];
        passee = dayjs().isAfter(dayjs(lastDate), "day")
        return passee;

    }

    function checkStarted(resa) {
        if (resa.CreneauEleves.length === 0) { return false; }
        let started = false;
        let dates = sortElevesCreneaux(resa.CreneauEleves).dateList;
        let lastDate = dates[dates.length - 1];
        let firstDate = dates[0];
        started = dayjs().isSameOrBefore(dayjs(lastDate), "day") && dayjs().isSameOrAfter(dayjs(firstDate), "day")
        return started;

    }

    function getNoMatchInfos(nb_modifs) {
        let info = "";
        if (nb_modifs % 2 === 0) {
            info += "Wally";
        }
        else {
            info += "client";
        }
        return info;

    }

    function getItemBgClass(resa) {
        let laClass = "manager-reservations-bottom-list-item";
        laClass += checkFinished(resa) ? " bg-finished " : "";
        laClass += checkStarted(resa) ? " bg-started " : "";
        return laClass;
    }

    function getResaDates(list) {
        let deb = dayjs(list[0]).format("DD/MM");
        let fin = dayjs(list[list.length - 1]).format("DD/MM");
        return deb + " -> " + fin;
    }


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <ManagerMenu current="reservations" />

                    <div className="manager-reservations">
                        <h1>Réservations</h1>
                        <div className="manager-reservations-top">
                            <div className="manager-reservations-top-searchbar">
                                <div>
                                    <TextField
                                        className="manager-reservations-top-searchbar-input"
                                        value={searchFilter}
                                        onChange={e => setSearchFilter(e.target.value)}
                                    />

                                    <Button
                                        className="manager-reservations-top-searchbar-btsearch"
                                        variant="contained"
                                        disabled={searchFilter.length === 0}
                                        onClick={_ => filterResas(searchFilter)}>
                                        Chercher
                                </Button>
                                    <Button
                                        className="manager-reservations-top-searchbar-bttous"
                                        variant="contained"
                                        onClick={_ => { setFilteredResas(resasInfos); setSearchFilter(""); }}>
                                        tous
                                </Button>
                                    <span
                                        className={"manager-reservations-top-searchbar-sort-match " + (searchFilter === "match" ? " sort-btn-pink " : " ") + (searchFilter === "unmatch" ? " sort-btn-black " : " ")}
                                        onClick={_ => { filterResas(searchFilter === "match" ? "unmatch" : "match") }}>
                                        <CheckIcon />
                                    </span>
                                    <span
                                        className={"manager-reservations-top-searchbar-sort-paid " + (searchFilter === "paid" ? " sort-btn-green " : " ") + (searchFilter === "unpaid" ? " sort-btn-black " : " ")}
                                        onClick={_ => { filterResas(searchFilter === "paid" ? "unpaid" : "paid") }}>
                                        <EuroIcon />
                                    </span>
                                </div>

                                <div>
                                    <p>Tri par :</p>
                                    <Button
                                        className={getBtClass("alpha")}
                                        variant="contained"
                                        onClick={_ => handleSort("alpha")}>
                                        Alphabet
                                    {listSorter.type === "alpha" ? listSorter.sens === "asc" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> : null}
                                    </Button>
                                    <Button
                                        className={getBtClass("date")}
                                        variant="contained"
                                        onClick={_ => handleSort("date")}>
                                        Date créa.
                                    {listSorter.type === "date" ? listSorter.sens === "asc" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> : null}
                                    </Button>
                                </div>
                            </div>

                        </div>

                        <div className="manager-reservations-bottom">
                            {
                                filteredResas && filteredResas.length === 0 && searchFilter.length > 0 ?
                                    <Alert severity="info">Aucun resa ne correspond à ce critère de recherche.</Alert>
                                    : null
                            }


                            {resasInfos.length > 0 ?
                                <div className="manager-reservations-bottom-list">
                                    {sortResas(filteredResas).map((resa) =>

                                        <section key={resa.id_resa}>
                                            <div className={getItemBgClass(resa)} onClick={_ => infosShower(resa.id_resa)}>
                                                <div>
                                                    <p className={resa.match === true ? resa.solde === 0 ? "resa-item-numresa resa-item-numresa-paid" : "resa-item-numresa resa-item-numresa-match" : "resa-item-numresa"}>{setNumResa(resa)}</p>
                                                    <p className={resa.coupon > 0 ? "resa-item-tarif resa-item-tarif-coupon" : "resa-item-tarif"}>{Math.round((100 - resa.coupon) / 100 * resa.total)},00€ {resa.coupon > 0 ? `(${resa.coupon}%)` : ""}</p>
                                                </div>
                                                <div>
                                                    <p>{getResaDates(sortElevesCreneaux(resa.CreneauEleves).dateList)}</p>
                                                    <p>{resa.Client.nom} {resa.Client.prenom}</p>
                                                </div>
                                                <div>
                                                    {resa.match === true ? <span className="resa-item-match"> <CheckIcon /></span> :
                                                        <span className={resa.nb_modifs % 2 === 0 ? "resa-item-nomatch-wally" : "resa-item-nomatch-client"}><AlarmOnIcon />{getNoMatchInfos(resa.nb_modifs)}</span>}
                                                    {resa.solde === 0 ? <span className="resa-item-euro"> <EuroIcon /></span> : null}
                                                    <p>{dayjs(resa.created).format("DD/MM/YYYY")}</p>
                                                </div>
                                            </div>
                                            {showInfos[resa.id_resa] === true ?
                                                <div className="manager-reservations-bottom-list-infos">

                                                    <div className="manager-reservations-bottom-accordeon-intro">
                                                        <div className="manager-reservations-bottom-accordeon-intro-left">
                                                            <div className="manager-reservations-bottom-accordeon-intro-date">
                                                                <p>Date de création : {dayjs(resa.created).format("DD/MM/YYYY")}</p>
                                                                {resa.match === false ? <h5>no match</h5> : null}
                                                            </div>
                                                            <div className="manager-reservations-bottom-accordeon-intro-modifs">
                                                                <p>Nombre de modifs : {resa.nb_modifs}</p>
                                                                {resa.match === false && resa.nb_modifs % 2 === 0 ?
                                                                    <Button
                                                                        className="manager-reservations-top-searchbar-btsearch"
                                                                        variant="contained"
                                                                        /* onClick={_ => navigate(`../editresa/${resa.id_resa}/${resa.client_id}`)} */
                                                                        onClick={_ => window.open(`${window.location.origin}/editresa/${resa.id_resa}/${resa.client_id}`)}
                                                                    >
                                                                        Editer la réservation
                                                                </Button>

                                                                    : null}
                                                            </div>
                                                            <div className="manager-reservations-bottom-accordeon-intro-tarifs">
                                                                <h4>Tarif : {Math.round((100 - resa.coupon) / 100 * resa.total)},00€ {resa.coupon > 0 ? ` (Réduction de ${resa.coupon}%)` : ""}</h4>
                                                                {resa.solde === 0 ? <p>Payé en ligne</p> : null}
                                                            </div>
                                                        </div>
                                                        <div className="manager-reservations-bottom-accordeon-intro-right">
                                                            <p>{resa.Client.prenom} {resa.Client.nom}</p>
                                                            <p>{resa.Client.tel}</p>
                                                            <p>{resa.Client.email}</p>
                                                        </div>

                                                    </div>
                                                    <div className="manager-reservations-bottom-accordeon-formules">
                                                        <h3>Sessions :</h3>
                                                        <div className="match-jours-manager">
                                                            {sortElevesCreneaux(resa.CreneauEleves) && sortElevesCreneaux(resa.CreneauEleves).dateList.map((date) => (
                                                                <div className="match-jours-manager-bloc" key={date}>
                                                                    <h3 className="match-jours-manager-bloc-date">{dayjs(date).format("DD/MM/YYYY")}</h3>
                                                                    {sortElevesCreneaux(resa.CreneauEleves).creneaux.filter((c) => c.date === date).map((creneau) => (
                                                                        <div className="match-jours-manager-bloc-creneau" key={creneau.id}>
                                                                            <p className="match-jours-manager-bloc-creneau-horaire">{convertHoraire(creneau.horaire, "horaire")}</p>
                                                                            <ul className="match-jours-manager-bloc-creneau-eleves">
                                                                                {creneau.eleves.map((e, index) => (
                                                                                    <li key={index}>{e.prenom}</li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    {resa.ResaCommentaires.length > 0 ?
                                                        <div className="manager-reservations-bottom-accordeon-commentaires">
                                                            <h3>Commentaires :</h3>
                                                            <div className="manager-reservations-bottom-accordeon-commentaires-list">
                                                                <Comments readOnly={true} comList={resa.ResaCommentaires.toSorted((c1, c2) => dayjs(c1.created).isAfter(dayjs(c2.created) ? -1 : 1))} client={resa.Client} />

                                                            </div>

                                                        </div>
                                                        : null}
                                                </div>
                                                : null}
                                        </section>

                                    )}
                                </div>
                                :
                                <CircularProgress />
                            }

                        </div>



                    </div>



                </div>
            </main>
        </div>
    );
}

export default ManagerReservations;